/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type StockOwnedCountQueryVariables = {|
  stockId?: ?string
|};
export type StockOwnedCountQueryResponse = {|
  +stockOwnedCount: ?any
|};
export type StockOwnedCountQuery = {|
  variables: StockOwnedCountQueryVariables,
  response: StockOwnedCountQueryResponse,
|};
*/


/*
query StockOwnedCountQuery(
  $stockId: ID
) {
  stockOwnedCount(stockId: $stockId)
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "stockId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "stockId",
        "variableName": "stockId"
      }
    ],
    "kind": "ScalarField",
    "name": "stockOwnedCount",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StockOwnedCountQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StockOwnedCountQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9bf90934e3cb2b8c99c773ba56f0c69f",
    "id": null,
    "metadata": {},
    "name": "StockOwnedCountQuery",
    "operationKind": "query",
    "text": "query StockOwnedCountQuery(\n  $stockId: ID\n) {\n  stockOwnedCount(stockId: $stockId)\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2c4279ab8c583049e299bd0a3f875121';

module.exports = node;
